/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".coupon-card-modal__header[_ngcontent-%COMP%]:after{display:none}"];
export { styles as styles };
